var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13179",
    "data-name": "Group 13179",
    transform: "translate(283.813 -39.555)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_660",
    "data-name": "Ellipse 660",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(-283.313 40.055)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12942",
    "data-name": "Group 12942",
    transform: "translate(-278.001 42.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11139",
    "data-name": "Path 11139",
    d: "M-243.8,62.251a.684.684,0,0,1,.688-.723.67.67,0,0,1,.688.723.677.677,0,0,1-.688.723A.683.683,0,0,1-243.8,62.251Zm.291-1.667-.163-5.595h1.119l-.163,5.595Z",
    transform: "translate(243.799 -54.99)",
    fill: "var(--mainColor)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.6455467736031d468fe25a7b7a1202e0.svg";
export { ForwardRef as ReactComponent };